import React, { FC } from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';

import { TPriceBlock, TPriceBlockValues } from '../../types';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

// Шаблон вывода цен вместе с юнитом
const getPriceWithUnit = (values: TPriceBlockValues) => {
  if (!values) {
    return null;
  }
  return (
    <span>
      <span className={cx('price-value')}>{values.price}</span> {values.unit}
    </span>
  );
};

export const PriceBlock: FC<{
  priceBlock: TPriceBlock;
}> = ({ priceBlock }) => {
  // Определяем, какой ценовой блок отображать
  const priceToDisplay =
    priceBlock.priceWithDiscount ?
      getPriceWithUnit(priceBlock.priceWithDiscount)
    : getPriceWithUnit(priceBlock.priceWithoutDiscount);

  // Флаг определяет отображение блока со старой ценой
  const shouldShowOriginalPrice =
    !!priceBlock.priceWithDiscount && !!priceBlock.priceWithoutDiscount;

  return (
    <div className={cx('wrapper', cnComponentsTheme('dark'))}>
      {!!priceBlock.conditionsText && (
        <Text color="secondary" variant="body-small">
          {priceBlock.conditionsText}
        </Text>
      )}
      <div className={cx('prices')}>
        {!!priceToDisplay && <Text variant="display-small">{priceToDisplay}</Text>}
        {shouldShowOriginalPrice && (
          <Text className={cx('with-discount')} color="tertiary-invert" variant="display-small">
            {getPriceWithUnit(priceBlock.priceWithoutDiscount)}
          </Text>
        )}
      </div>
    </div>
  );
};
